import * as Icons from 'react-icons/bs';

export enum EMenuItemTypes {
  TEXT = 'text-item',
  ICON = 'icon-item',
  TEXT_ICON = 'text-icon-item',
  SPACER = 'spacer',
}

export enum EMenuSubItemTypes {
  SUB_ITEM = 'sub-item',
  SPACER = 'spacer'
}

export enum EMenuItems {
  LAWS = 'laws',
  TEXT = 'text',
  VISUALIZE = 'visualize',
  NAVIGATE = 'navigate',
  WINDOWS = 'windows',
  HELP = 'help',

  DOC_ACTIONS = 'doc-actions',
  MINIMIZE = 'minimize',
  RESTORE = 'restore',
  MAXIMIZE = 'maximize',

  SEARCH = 'search',
  PRINT = 'print',
  PRINT_SELECTION = 'print-selection',
  EXPORT_DOCX = 'export-docx',
  EXPORT_PDF = 'export-pdf',
  BACK = 'back',
  FORWARD = 'forward',
  LINKS = 'links',
  HISTORY = 'history',
  BOOKMARKS = 'favorites',
  WORDS = 'words',
}

export type TMenuSubItem = {
  type: EMenuSubItemTypes.SUB_ITEM,
  name: string,
  label: string,
  visible: boolean,
  disabled?: boolean,
  truncate?: boolean,
  ticked?: boolean,
  shortcut?: {
    key: string,
    isCTRL?: boolean,
    isALT?: boolean,
    isShift?: boolean,
  },
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void,
}

export type TSubMenuSpacer = {
  type: EMenuSubItemTypes.SPACER,
  visible: boolean,
  orientation: 'row' | 'column'
}

export type TMenuSpacer = {
  type: EMenuItemTypes.SPACER,
  orientation: 'row' | 'column'
}

export type TMenuItemBase = {
  name: EMenuItems,
  disabled?: boolean,
  contents: (TMenuSubItem | TSubMenuSpacer)[],
  hideIfNoContents?: boolean,
  onClick?: () => void,
}

export type TMenuTextItem = TMenuItemBase & {
  type: EMenuItemTypes.TEXT,
  label: string,
}

export type TMenuIconItem = TMenuItemBase & {
  type: EMenuItemTypes.ICON,
  icon: JSX.Element,
}

export type TMenuTextAndIconItem = TMenuItemBase & {
  type: EMenuItemTypes.TEXT_ICON,
  label: string,
  icon: JSX.Element,
}

export type TMenuItem = TMenuTextItem | TMenuIconItem | TMenuTextAndIconItem | TMenuSpacer;

